// import localScaleManager from "../../../helpers/LocalScaleManager";
// import { tweenConfigs } from "../../../helpers/tweensConfigs";
import { WebSocketManager } from "../../../helpers/webSocketManager";

export class ActionButton {
  /**
   * @param scene {GameScene}
   * @param table {Table}
   * @param texture {string}
   * @param serverEventAddress {string}
   * @param isReserveBtn {Boolean}
   * @param gameObj {Phaser.GameObjects.Image}
   */
  constructor(
    scene,
    table,
    texture,
    serverEventAddress,
    isReserveBtn,
    gameObj
  ) {
    // if (atlas) super(scene, 0, 0, scene.atlasTexture, texture);
    // else super(scene, 0, 0, texture);
    this.tableNumber = table.tableNumber;
    this.scene = scene;
    this.gameObj = gameObj;
    this.mainTexture = texture;
    this.isReserveBtn = isReserveBtn;
    this.reserveBtnClicked = false;
    this.serverEventAddress = serverEventAddress;
    this.table = table;
    // this.initScale = 1;
    this.scaleTweenDuration = 50;
    // this.scene.add.existing(this);
    // this.table.poolArray.push(this);

    // this.setInteractive({ cursor: "pointer" });
    // this.on("pointerdown", this.scaleTween, this);
    // this.on("pointerout", this.unscaleTween, this);
    // this.on("pointerup", this.onClick, this);
    // if (this.isReserveBtn) {
    //   this.checkMark = this.scene.add
    //     .sprite(0, 0, this.scene.atlasTexture, "button-check-mark")
    //     .setVisible(false);
    //   this.table.poolArray.push(this.checkMark);
    // }
    this.btnClicked = false;
    this.foldConfirmation = false;
    this.shown = false;
  }
  enableInteractive() {
    this.gameObj.setInteractive({ cursor: "pointer" });
    this.gameObj.off("pointerdown");
    this.gameObj.off("pointerout");
    this.gameObj.off("pointerup");
    this.gameObj.on("pointerdown", this.scaleTween, this);
    this.gameObj.on("pointerout", this.unscaleTween, this);
    this.gameObj.on("pointerup", this.onClick, this);
  }
  disableInteractive() {
    this.gameObj.disableInteractive();
    this.gameObj.off("pointerdown");
    this.gameObj.off("pointerout");
    this.gameObj.off("pointerup");
  }
  scaleTween() {
    if (this.btnClicked) return;
    this.btnClicked = true;
    if (this.scene.tweenEnable) {
      this.scene.tweens.add({
        targets: this.gameObj,
        duration: this.scaleTweenDuration,
        ease: "Linear",
        scale: this.gameObj.scale * 0.95,
      });
    }
  }
  unscaleTween() {
    this.btnClicked = false;
    if (this.scene.tweenEnable) {
      this.scene.tweens.add({
        targets: this.gameObj,
        duration: this.scaleTweenDuration,
        ease: "Linear",
        scale: this.gameObj.getData("initScale"),
        onComplete: () => {
          this.gameObj.setScale(this.gameObj.getData("initScale"));
        },
      });
    }
  }
  async onClickTween() {
    return new Promise((resolve) => {
      if (this.isReserveBtn) {
        // if (!this.checkMark.visible) {
        if (!this.reserveBtnClicked) {
          this.table.buttonManager.reserveButtonsGroup.forEach((btn) => {
            // btn.checkMark.setVisible(false);
            if (btn.shown) btn.activeReserveBtn(false);
          });
        }
        // this.checkMark.setVisible(!this.checkMark.visible);
        this.activeReserveBtn(!this.reserveBtnClicked);
      }
      if (this.scene.tweenEnable) {
        this.scene.tweens.add({
          targets: this.gameObj,
          duration: this.scaleTweenDuration,
          ease: "Linear",
          scale: this.gameObj.getData("initScale"),
          onComplete: () => {
            this.gameObj.setScale(this.gameObj.getData("initScale"));
            resolve();
          },
        });
      } else {
        resolve();
      }
    });
  }
  activeReserveBtn(reserveStatus = false) {
    const texture = reserveStatus ? `${this.mainTexture}-on` : this.mainTexture;
    this.reserveBtnClicked = reserveStatus;
    if (this.gameObj.frame.name !== texture)
      this.gameObj.setFrame(texture, false, false);
  }
  onClick() {
    if (this.scene.isSceneObjectsInteractive && this.btnClicked) {
      if (this.foldConfirmation) {
        this.table.modalsManager.notice.show(
          "Are You Sure You Want To Fold?",
          () => {
            this.sendAction();
          }
        );
      } else {
        this.sendAction();
      }
    }
  }
  async sendAction() {
    let eventAddress = "";
    this.disableInteractive();
    try {
      await this.onClickTween();
    } catch (e) {
      console.log(e);
    }
    this.btnClicked = false;
    const data = {
      tableId: this.table.tableInfo.id,
    };
    if (!this.isReserveBtn) {
      // this.table.buttonManager.hideActionButtons();
      // this.table.buttonManager.hideOtherButtons();
      this.table.buttonManager.hideAllButtons();
    }
    eventAddress =
      this.isReserveBtn && !this.reserveBtnClicked
        ? "poker.client-push.auto-action-none"
        : this.serverEventAddress;
    let timeout = setTimeout(() => {
      // this.enableInteractive();
      this.table.buttonManager.handleGameState(this.table.gameState);
    }, 3000);
    WebSocketManager.emitEvent(data, eventAddress)
      .then(() => {
        this.enableInteractive();
      })
      .catch((e) => {
        console.log("catch");
        console.log(e);
        this.table.buttonManager.handleGameState(this.table.gameState);
      })
      .finally(() => {
        // this.enableInteractive();
        clearTimeout(timeout);
        timeout = null;
      });
  }

  /**
   * @param reserveStatus {boolean}
   * @param foldConfirmation {boolean}
   */
  show(reserveStatus, foldConfirmation) {
    // this.initScale = this.scale;
    this.shown = true;
    this.enableInteractive();
    if (this.gameObj.frame.name !== this.mainTexture)
      this.gameObj.setFrame(this.mainTexture, false, false);
    if (!this.gameObj.visible) this.gameObj.setVisible(true);
    this.foldConfirmation = foldConfirmation;
    if (this.isReserveBtn) {
      this.activeReserveBtn(reserveStatus);
    }
    // if (this) {
    // if (this.scene.tweenEnable) {
    //   this.scene.tweens.add({
    //     targets: this,
    //     duration: tweenConfigs.actionButtons.show.duration,
    //     ease: tweenConfigs.actionButtons.show.ease,
    //     y: this.btnInitY,
    //     onComplete: () => {
    //       this.y = this.btnInitY;
    //     },
    //   });
    // } else {
    // this.y = this.btnInitY;
    // }
    // }

    // this.setInteractive({ cursor: "pointer" });
  }
  hide() {
    this.shown = false;
    if (this.foldConfirmation) {
      this.table.modalsManager.notice.hide();
    }
    this.foldConfirmation = false;
    // if (this.isReserveBtn) {
    //   this.activeReserveBtn(false);
    // }
    // if (this.scene.tweenEnable) {
    //   this.scene.tweens.add({
    //     targets: this,
    //     duration: tweenConfigs.actionButtons.hide.duration,
    //     ease: tweenConfigs.actionButtons.hide.ease,
    //     y: this.scene.gameHeight + this.displayHeight,
    //     onComplete: () => {
    //       this.y = this.scene.gameHeight + this.displayHeight;
    //       // this.setVisible(false);
    //     },
    //   });
    // } else {
    // this.y = this.scene.gameHeight + this.displayHeight;
    // if (this.gameObj.visible) this.gameObj.setVisible(false);
    // }
  }
  /***
   * @param width {number} table.displayWidth
   * @param height {number} table.displayHeight
   * @param btnPosition {string | left | center | right}
   */
  positionControls(width, height, btnPosition) {
    // this.tableNumber = this.table.tableNumber;
    // const initX = this.scene.gameWidth * (this.tableNumber - 1);
    // let btnX = 0;
    // let btnSize = width / 3.1;
    // localScaleManager.scaleSprite(this, btnSize, btnSize, 0, 1, true);
    // this.initScale = this.scale;
    // switch (btnPosition) {
    //   case "left": {
    //     btnX = initX + this.scene.gameWidth / 2 - this.displayWidth - 3;
    //     break;
    //   }
    //   case "center": {
    //     btnX = initX + this.scene.gameWidth / 2;
    //     break;
    //   }
    //   case "right": {
    //     btnX = initX + this.scene.gameWidth / 2 + this.displayWidth + 3;
    //     break;
    //   }
    // }
    // this.setPosition(btnX, this.scene.gameHeight - this.displayHeight);
    // this.btnInitY = this.y;
    // this.hide();
  }
  /***
   * @param width {number} table.displayWidth
   * @param height {number} table.displayHeight
   * @param btnPosition {string | left | center | right}
   */
  reposition(width, height, btnPosition) {
    // this.tableNumber = this.table.tableNumber;
    // const initX = this.scene.gameWidth * (this.tableNumber - 1);
    // let btnX = 0;
    // switch (btnPosition) {
    //   case "left": {
    //     btnX = initX + this.scene.gameWidth / 2 - this.displayWidth - 3;
    //     break;
    //   }
    //   case "center": {
    //     btnX = initX + this.scene.gameWidth / 2;
    //     break;
    //   }
    //   case "right": {
    //     btnX = initX + this.scene.gameWidth / 2 + this.displayWidth + 3;
    //     break;
    //   }
    // }
    // this.setPosition(btnX, this.scene.gameHeight - this.displayHeight);
    // this.btnInitY = this.y;
  }
  remove() {
    this.destroy();
    // if (this.checkMark) this.checkMark.destroy();
  }
}
